// <mega-nav>: desktop hover mega panels, mobile off-canvas drawer
// with per-department accordions.
customElements.define(
  "mega-nav",
  class extends HTMLElement {
    connectedCallback() {
      this.mq = window.matchMedia("(min-width: 1280px)");
      this.drawer = this.querySelector("[data-nav-drawer]");
      this.scrim = this.querySelector("[data-nav-scrim]");

      this.querySelectorAll("[data-mega-dept]").forEach((dept) => {
        const trigger = dept.querySelector("[data-mega-trigger]");
        const panel = dept.querySelector("[data-mega-panel]");
        if (!trigger || !panel) return;
        trigger.addEventListener("mouseenter", () => {
          if (this.mq.matches) this.openPanel(panel, trigger);
        });
        // Keyboard: open on focus entering the department, close when focus leaves it.
        dept.addEventListener("focusin", () => {
          if (this.mq.matches) this.openPanel(panel, trigger);
        });
        dept.addEventListener("focusout", (e) => {
          if (this.mq.matches && !dept.contains(e.relatedTarget)) this.closePanels();
        });
        trigger.addEventListener("click", () => {
          if (this.mq.matches) {
            if (trigger.dataset.url) window.location.href = trigger.dataset.url;
          } else {
            const wasOpen = panel.classList.contains("is-open");
            panel.classList.toggle("is-open", !wasOpen);
            trigger.setAttribute("aria-expanded", String(!wasOpen));
          }
        });
      });

      this.addEventListener("mouseleave", () => this.mq.matches && this.closePanels());
      this.querySelectorAll("[data-nav-open]").forEach((b) => b.addEventListener("click", () => this.openDrawer()));
      this.querySelectorAll("[data-nav-close]").forEach((b) => b.addEventListener("click", () => this.closeDrawer()));
      if (this.scrim) this.scrim.addEventListener("click", () => this.closeDrawer());
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") { this.closePanels(); this.closeDrawer(); }
      });
    }
    openPanel(panel, trigger) {
      this.closePanels();
      panel.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
      trigger.classList.add("text-primary");
    }
    closePanels() {
      this.querySelectorAll("[data-mega-panel]").forEach((p) => p.classList.remove("is-open"));
      this.querySelectorAll("[data-mega-trigger]").forEach((t) => {
        t.setAttribute("aria-expanded", "false");
        t.classList.remove("text-primary");
      });
    }
    openDrawer() {
      this.drawer.classList.add("is-open");
      if (this.scrim) this.scrim.classList.add("is-open");
      if (!this.mq.matches) this.querySelectorAll("[data-mega-panel]").forEach((p) => p.classList.remove("is-open"));
      document.body.style.overflow = "hidden";
    }
    closeDrawer() {
      this.drawer.classList.remove("is-open");
      if (this.scrim) this.scrim.classList.remove("is-open");
      document.body.style.overflow = "";
    }
  }
);
